import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=28f27e20"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"
import style0 from "./articles.vue?vue&type=style&index=0&id=28f27e20&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f27e20')) {
      api.createRecord('28f27e20', component.options)
    } else {
      api.reload('28f27e20', component.options)
    }
    module.hot.accept("./articles.vue?vue&type=template&id=28f27e20", function () {
      api.rerender('28f27e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/articles.vue"
export default component.exports